import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportAssistenciaTecnicaBasicoUseCase } from "../../../presentation/useCases/read/get_report_assistencia_tecnica_basico_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportAssistenciaTecnicaBasicoUseCase
 */

export class GetReportAssistenciaTecnicaBasicoUseCase implements IGetReportAssistenciaTecnicaBasicoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportAssistenciaTecnicaBasico(
    requiredMimeType: ReportMimeType | null,
    idAssistenciaTecnica: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportAssistenciaTecnicaBasico(requiredMimeType, idAssistenciaTecnica);

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `assistencia_tecnica_basico_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
